import React from 'react';
import { Formik, Form, Field } from 'formik';
import { MenuItem, Button, TextField } from '@mui/material';
import * as Yup from 'yup';
import { TrainingRequests } from 'requests/TrainingRequests';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const validationSchema = Yup.object({
  newTrainingType: Yup.string().required('Please select a training type'),
  reason: Yup.string().required('Please enter a reason'),
});

const ChangeTrainingTypeForm = ({
  batchId,
  currentTrainingType,
  closeModal,
  onSuccess,
  trainingTypes = [],
}) => {
  const availableTypes = trainingTypes.filter((t) => t.trainingName !== currentTrainingType);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await TrainingRequests.changeTrainingType(batchId, values.newTrainingType, values.reason);
      toast.success('Training type changed successfully', { theme: 'colored' });
      if (onSuccess) onSuccess();
      if (closeModal) closeModal();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to change training type', {
        theme: 'colored',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ newTrainingType: '', reason: '' }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, setFieldValue, isSubmitting }) => (
        <Form>
          <Field
            name="newTrainingType"
            as={TextField}
            select
            label="New Training Type"
            fullWidth
            margin="normal"
            error={touched.newTrainingType && !!errors.newTrainingType}
            helperText={touched.newTrainingType && errors.newTrainingType}
            onChange={(e) => setFieldValue('newTrainingType', e.target.value)}
          >
            {availableTypes.map((type) => (
              <MenuItem key={type.trainingName} value={type.trainingName}>
                {type.trainingName.replace(/_/g, ' ')}
              </MenuItem>
            ))}
          </Field>

          <Field
            name="reason"
            as={TextField}
            label="Reason"
            fullWidth
            margin="normal"
            multiline
            rows={4}
            error={touched.reason && !!errors.reason}
            helperText={touched.reason && errors.reason}
            onChange={(e) => setFieldValue('reason', e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isSubmitting}
            sx={{ mt: 2 }}
          >
            {isSubmitting ? 'Changing...' : 'Change Training Type'}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default ChangeTrainingTypeForm;
